export const SET_SALE_ORDER_STATUSES_TEXT = 'SET_SALE_ORDER_STATUSES_TEXT';
